import { useDataGridContext } from '@issuemanager/apps/client/components';
import { useEventCallback } from '@mui/material';
import { DateRange } from '@mui/x-date-pickers-pro/DateRangePicker';
import { DateFilter } from '../../../../components/filters/date-filter';
import { IssueGridFilterModel } from './types';

export function IssueGridDueDateFilter() {
  const context = useDataGridContext();

  const { dueDate: issueDueDate, actionDueDate }: IssueGridFilterModel =
    context.filterModel;

  const handleChange = useEventCallback((value: DateRange<Date>) => {
    context.setFilterModel({
      ...context.filterModel,
      dueDate: value,
      actionDueDate: value,
    });
  });

  const value: DateRange<Date> = [
    issueDueDate?.[0] ?? actionDueDate?.[0] ?? null,
    issueDueDate?.[1] ?? actionDueDate?.[1] ?? null,
  ];

  return <DateFilter onChange={handleChange} value={value} />;
}
